module.exports = __webpack_public_path__ + "static/media/bannerRedV2.26f40267.png";